import { useNavigate } from "react-router-dom";

import { useQueryClient } from "@tanstack/react-query";

import { GENERAL_ROUTES } from "../../routes/routes";
import { logoutWithWorker } from "../../utils";

const logout = () => {
  logoutWithWorker();
  postMessage({ type: "LOG_OUT" }, "*");
};

export const useLogout = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return {
    mutate: () => {
      queryClient.clear();
      logout();
      navigate(GENERAL_ROUTES.Index);
    },
  };
};
